import { usePermissionsContext } from '../Context/PermissionsContext';

// Thin wrapper kept at the same name/shape as before this redesign, so none
// of its 15+ call sites need to change. The actual fetch now lives in
// PermissionsContext (one fetch per login, shared here) instead of each
// consumer of this hook firing its own request.
const usePermissions = () => {
  const context = usePermissionsContext();
  const permissions = context?.permissions ?? null;
  const loading = context?.loading ?? true;
  const error = context?.error ?? null;

  const canCreatePage = (pageName) => permissions?.pages?.find(p => p.pageName === pageName)?.canCreate || false;
  const canReadPage = (pageName) => permissions?.pages?.find(p => p.pageName === pageName)?.canRead || false;
  const canApplyDiscount = () => permissions?.canApplyCustomDiscount || false;
  const canDownloadReports = () => permissions?.canDownloadPdfReports || false;
  const canOverridePrice = () => permissions?.canOverridePrice || false;
  const canUpdatePage = (pageName) => permissions?.pages?.find(p => p.pageName === pageName)?.canUpdate || false;
  const canDeletePage = (pageName) => permissions?.pages?.find(p => p.pageName === pageName)?.canDelete || false;
  // Was: read a stale localStorage snapshot of userType, which didn't update
  // until the next login. Now reads the live server response - the server
  // is the one place that actually knows the user's current role.
  const isAdmin = () => permissions?.isAdmin || false;

  return {
    permissions,
    loading,
    error,
    canApplyDiscount,
    canUpdatePage,
    canDeletePage,
    isAdmin,
    canCreatePage,
    canReadPage,
    canDownloadReports,
    canOverridePrice,
    refreshPermissions: context?.refreshPermissions,
  };
};

export default usePermissions;
